import Vue from 'vue';
import axios from './axios.js';
import store from '../store/index.js';
import ErrorMessage from '../components/ErrorMessage.vue';

class Errors {
    constructor() {
        this.errors = {};
    }

    hasAny() {
        return !!Object.keys(this.errors).length;
    }

    has(key) {
        return this.errors[key] !== undefined;
    }

    first(key) {
        if (this.has(key)) {
            return this.errors[key][0];
        }

        return null;
    }

    get(key) {
        if (this.has(key)) {
            return this.errors[key];
        }

        return null;
    }

    all() {
        return this.errors;
    }

    fill(values) {
        this.errors = values;
    }

    flush() {
        this.errors = {};
    }
}

const errors = new Errors();

// Intercept axios request
axios.interceptors.request.use(
    config => {
        if (['put', 'post', 'patch', 'delete'].includes(config.method)) {
            errors.flush();
        }

        return config;
    },
    error => Promise.reject(error),
);

// Intercept axios responses
axios.interceptors.response.use(
    response => {
        return response;
    },
    error => {
        if (error.response) {
            // Not authorized
            if (error.response.status == 401) {
                store.dispatch('clearAuthUser');
            }

            // Validation error
            if (error.response.status === 422) {
                errors.fill(error.response.data.errors);
            }
        }

        return Promise.reject(error);
    },
);

Vue.mixin({
    beforeCreate() {
        this.$options.$errors = {};

        Vue.util.defineReactive(this.$options, '$errors', errors);

        if (!this.$options.computed) {
            this.$options.computed = {};
        }

        this.$options.computed.$errors = () => {
            return this.$options.$errors;
        };
    },
});

Vue.component('error-message', ErrorMessage);

export default errors;
